import camelCase from "./camelCase.js";
import core from "../setup";

core.camelCase = camelCase;
